import { redirect } from '@tanstack/react-router';
import { profileApi } from 'store/slices/profile-api';
import { preloadQueries } from './preloading';

// Route guard for flows that require a verified (KYC) customer.
// Use in `beforeLoad` so direct URL access is blocked too, not just the buttons.
export async function requireVerified() {
  const [res] = await preloadQueries(profileApi.endpoints.getProfile.initiate());

  if (res.data?.verificationStatus != 'Verified') {
    throw redirect({ to: '/verification' });
  }
}
